import { render } from "./WalletExplorar.vue?vue&type=template&id=b9b85fc6&scoped=true"
import script from "./WalletExplorar.vue?vue&type=script&lang=js"
export * from "./WalletExplorar.vue?vue&type=script&lang=js"

import "./WalletExplorar.vue?vue&type=style&index=0&id=b9b85fc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b85fc6"]])

export default __exports__